import { Extension } from '@tiptap/core';
import { Plugin } from 'prosemirror-state';

export const BottomBlock = Extension.create({
    name: 'bottomBlock',
    
    addProseMirrorPlugins() {
        return [
            new Plugin({
                appendTransaction: (transactions, oldState, newState) => {
                    // Only proceed if content actually changed
                    if (!transactions.some(tr => tr.docChanged)) return null;
                    
                    const { doc, tr } = newState;
                    const bottomBlocks = [];
                    
                    // Find all bottom blocks
                    doc.forEach((node, offset) => {
                        const isBottomBlock = node.attrs.isBottomBlock || 
                                           (node.attrs.class && node.attrs.class.includes('bottom-block'));
                        if (isBottomBlock) {
                            bottomBlocks.push({ node, offset });
                        }
                    });
                    
                    // If there's exactly one bottom block and it has content,
                    // convert it to a regular block and we'll add a new bottom block
                    if (bottomBlocks.length === 1) {
                        const { node, offset } = bottomBlocks[0];
                        if (node.content.size > 0) {
                            tr.setNodeMarkup(offset, undefined, {
                                class: 'editor-paragraph',
                                isBottomBlock: false
                            });
                            bottomBlocks.length = 0; // Clear the array to trigger bottom block creation
                        }
                    }
                    
                    // If there are no bottom blocks, add one at the end
                    if (bottomBlocks.length === 0) {
                        const type = newState.schema.nodes.paragraph;
                        tr.insert(doc.content.size, type.create({
                            class: 'editor-paragraph bottom-block',
                            isBottomBlock: true
                        }));
                        return tr;
                    }
                    
                    // If there's more than one bottom block, keep only the last one
                    if (bottomBlocks.length > 1) {
                        // Remove all except the last one
                        bottomBlocks.slice(0, -1).reverse().forEach(({ offset, node }) => {
                            tr.delete(offset, offset + node.nodeSize);
                        });
                        return tr;
                    }
                    
                    // If there's exactly one bottom block but it's not at the end,
                    // move it to the end
                    if (bottomBlocks.length === 1) {
                        const { offset, node } = bottomBlocks[0];
                        if (offset + node.nodeSize !== doc.content.size) {
                            tr.delete(offset, offset + node.nodeSize)
                              .insert(doc.content.size, node);
                            return tr;
                        }
                    }
                    
                    return null;
                }
            })
        ];
    }
});
